import {
  Box,
  TextField,
  Typography,
  InputAdornment,
  InputLabel,
  FormHelperText,
  Grid,
} from "@mui/material";

import lockicon from "../../../images/lockIcon.png";

import _ from "lodash";
import { useEffect, useState } from "react";
import { customAlphabet } from "nanoid";
import CurrencyInput from "./CurrencyInput";
import { BorderAllRounded } from "@mui/icons-material";
const nanoid = customAlphabet("1234567890ABCDEFGHIJKLMNOPQRSTUZVWXYZ", 6);

export const TransTextInput = ({
  label,
  placeholder,
  value,
  onChange,
  inputAdornments,
  width,
  height,
  sx,
  customsx,
  wrapperSx,
  type,
  name,
  validation,
  errors,
  key,
  isDisabled,
  mode,
  max,
  autoGenerate,
  customeonchange
}) => {

  useEffect(() => {
    if (autoGenerate && !value && mode === "new") {
      onChange(name, nanoid());
    }
  }, [autoGenerate, mode, name, onChange, value]);

  const onTextChange = (e) => {
    if(customeonchange){
      customeonchange(e.target.value)
    }
    return onChange(name, e.target.value);
  };
  
  // Initialize state based on the original type
  const [eyeOpen, setEyeOpen] = useState(false);
  const [customType, setCustomType] = useState(type);

  // Reset states when type prop changes
  useEffect(() => {
    setEyeOpen(false);
    setCustomType(type);
  }, [type]);

  const typeChange = () => {
    if (type === 'password') {
      setEyeOpen(!eyeOpen);
      setCustomType(eyeOpen ? 'password' : 'text');
    }
  };

  // Determine if this is a password field that should show toggle
  const isPasswordField = type === 'password';
  const shouldShowToggle = isPasswordField && inputAdornments?.end;

  return (
    <Box sx={{ ...wrapperSx }} key={key}>
      <InputLabel htmlFor={name} component="div" sx={{ fontWeight: 600, fontSize: 16, color: '#000', error: errors?.status }}>
        {label}
        {validation?.required && <Typography component="span" sx={{ color: 'red', marginLeft: '4px' }}>*</Typography>}
      </InputLabel>
      <TextField
        type={customType}
        variant="outlined"
        disabled={isDisabled || mode === "view"}
        placeholder={placeholder}
        value={value}
        onChange={onTextChange}
        error={errors?.status}
        sx={{ backgroundColor: isDisabled ? '#E2E8F0' : 'initial', width: width || "auto", height, ...sx }}
        InputProps={{
          sx: customsx ? customsx : { borderRadius: '4px' },
          endAdornment: inputAdornments?.end && (
            <InputAdornment 
              position="end" 
              onClick={shouldShowToggle ? typeChange : undefined}
              sx={{ cursor: shouldShowToggle ? 'pointer' : 'default' }}
            >
              <Typography color="#111111">{inputAdornments?.end}</Typography>
            </InputAdornment>
          ),
        }}
      />

      {errors?.status && (
        <FormHelperText error={errors.status}>
          {_.capitalize(errors?.message)}
        </FormHelperText>
      )}
    </Box>
  );
};